module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x2-4acdb41f6ecfcd6ead68f20c4d7bed26.jpg";